
<div class="toggle-container">
  <div class="toggle">
    <button
      :class="{'active': isBuyActive}"
      @click="toggle('buy')"
      class="toggle-button"
    >
      Buy
    </button>
    <button
      :class="{'active': !isBuyActive}"
      @click="toggle('rent')"
      class="toggle-button"
    >
      Rent
    </button>
  </div>
</div>
